<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Payment Source</h1>
    <p>The payment source tells the pension provider where the pension contributions are coming from — for example, which bank account is being used.</p>
    <p>Please provide the details of the payment sources in use by your company.</p>
  </div>
    <div class="cell small-12">
      <EditableTable
        v-model="formData.paymentSources"
        :columns="columns"
        :buttonName="'Add Payment Source'"
      />
    </div>




</template>


<script setup>

import { ref, onMounted } from 'vue'
import EditableTable from '@/components/controls/EditableTable.vue';

const error = ref([]);

const props = defineProps({
  formData: Object
})



const columns = [
  { field: 'paymentSourceName', label: 'Payment Source Name', type: 'text', placeholder: 'Payment Source Name' },
]


const validateStep = () => {
  error.value = [];


  if (props.formData.paymentSources.length === 0) {
    error.value.push('At least one Payment Source must be provided.');
  }

  if (error.value.length > 0) return false;
  

  return true;
}



const executeStep = async () => {


  return true;
}



onMounted(() => {


});

defineExpose({ validateStep, executeStep });

</script>